import React from 'react';
import Contract from './subcomponents/DibbsContract';
import Pricing from './subcomponents/DibbsPricing';
import PriceBreaks from './subcomponents/DibbsPriceBreaks';
import Product from './subcomponents/DibbsProduct';
import Company from './subcomponents/DibbsCompany';
import Review from './subcomponents/DibbsReview';
import PdfViewer from './subcomponents/DibbsPdfViewer';

const Components = {
  pdf: PdfViewer,
  contract: Contract,
  pricing: Pricing,
  priceBreaks: PriceBreaks,
  product: Product,
  company: Company,
  review: Review,
};

export default block => {
  console.log(block);
  if (typeof Components[block[0]] !== 'undefined') {
    if (block[1]) {
      return React.createElement(
        Components[block[0]],
        {
          data: block[1],
        },
        React.createElement('div', { id: `${block[0]}` }),
      );
    }
    return React.createElement(() => <div />);
  }
  return React.createElement(
    () => <div>The component {block[0]} has not been created yet.</div>,
    { key: block._uid },
  );
};



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/DibbsWizardBuilder.jsx